module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (6).46a5f599.svg";